<template>
  <div class="sub-toolbar">
    <project-toolbar :selectMonth="false">
      <md-menu
        v-if="canDownload"
        md-align-trigger
        md-size="small"
        style="border-left: none"
      >
        <md-button md-menu-trigger>{{ L('download') }}</md-button>
        <md-menu-content>
          <md-menu-item @click="download('xlsx')">XLSX</md-menu-item>
          <md-menu-item @click="download('csv')">CSV</md-menu-item>
        </md-menu-content>
      </md-menu>
      <!-- Tag Categories 숨김 스위치 -->
      <span v-if="$config.feature.tags" class="box-left-edge">
        <md-checkbox
          style="font-weight: 500; width: 140px"
          v-model="isTagsShow"
          class="md-primary"
          :disabled="!disabled"
          >{{ L('showTag') }}</md-checkbox
        >
      </span>
      <!--Preset Menu-->
      <md-menu md-align-trigger md-size="small">
        <md-button md-menu-trigger :disabled="!disabled">
          {{ L('preset') }}
          <span v-if="selectedPreset">: {{ selectedPreset.name }}</span>
        </md-button>
        <md-menu-content>
          <md-menu-item
            :class="'presetList'"
            v-if="selectedPreset"
            @click="save()"
            >{{ L('save') }} : {{ selectedPreset.name }}</md-menu-item
          >
          <md-menu-item
            :class="'presetList'"
            v-if="selectedPreset"
            @click="openRemove()"
            >{{ L('remove') }} : {{ selectedPreset.name }}</md-menu-item
          >
          <md-menu-item :class="'presetList'" @click="openSaveAs()"
            >{{ L('saveAs') }}...</md-menu-item
          >
          <md-divider></md-divider>
          <md-menu-item :class="'presetList'" v-if="presets.length === 0"
            >({{ L('empty') }})</md-menu-item
          >
          <md-menu-item
            :class="'presetList'"
            v-for="preset in presets"
            :key="preset.name"
            @click="loadPreset(preset)"
            >{{ preset.name }}</md-menu-item
          >
        </md-menu-content>
      </md-menu>
      <!--select Date Menu-->
      <md-menu>
        <md-button class="account-btn" md-menu-trigger>{{
          L(dateType)
        }}</md-button>
        <md-menu-content>
          <md-menu-item :class="'presetList'" @click="monthType('oneMonth')">{{
            L('oneMonth')
          }}</md-menu-item>
          <md-menu-item
            :class="'presetList'"
            @click="monthType('threeMonths')"
            >{{ L('threeMonths') }}</md-menu-item
          >
          <md-menu-item :class="'presetList'" @click="monthType('range')">{{
            L('range')
          }}</md-menu-item>
        </md-menu-content>
      </md-menu>
      <!--New Date Search Part Start-->
      <md-menu
        md-align-trigger
        md-size="small"
        v-show="useSelectBox"
        class="sub-toolbar-last-menu"
      >
        <md-button class="account-btn" md-menu-trigger>
          {{ months.join('~') }}
          <fa-icon icon="caret-down" />
        </md-button>
        <md-menu-content>
          <md-menu-item
            v-for="month in monthArray"
            :key="month"
            class="account-item"
            @click="changeMonth(month)"
            >{{ month }}</md-menu-item
          >
        </md-menu-content>
      </md-menu>
      <md-datepicker
        :md-disabled-dates="disableStrDates()"
        v-model="pickupStrMonth"
        v-show="!useSelectBox"
        :class="'datePicker'"
      ></md-datepicker>
      <md-datepicker
        :md-disabled-dates="disableEndDates()"
        v-model="pickupEndMonth"
        v-show="!useSelectBox"
        :class="'datePicker'"
      ></md-datepicker>
      <!--New Date Search Part End-->
    </project-toolbar>

    <md-content>
      <div style="display: flex">
        <md-button class="md-primary md-raised loadBtn" @click="loadData()">
          {{ L('load') }}
        </md-button>
      </div>
      <div ref="pivot" @change="pivotChanged" />
    </md-content>

    <!-- add dialog -->
    <md-dialog :md-active.sync="dialog.saveAs">
      <md-dialog-title>{{ L('saveAs') }}</md-dialog-title>

      <md-dialog-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-small-size-100">
            <md-field :class="`${dialog.duplicate ? 'md-invalid' : ''}`">
              <label>{{ L('name') }}</label>
              <md-input v-model="dialog.item.name" />
              <span class="md-error">{{ L('duplicate') }}</span>
            </md-field>
          </div>
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSaveAs()">{{
          L('cancel')
        }}</md-button>
        <md-button class="md-primary md-raised" @click="saveAs()">{{
          L('save')
        }}</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- remove confirm dialog -->
    <md-dialog-confirm
      v-if="selectedPreset"
      :md-active.sync="dialog.remove"
      :md-title="L('removePreset')"
      :md-content="L('confirmRemove') + ` ${selectedPreset.name}?`"
      :md-confirm-text="L('remove')"
      :md-cancel-text="L('cancel')"
      @md-confirm="remove()"
    />
  </div>
</template>

<script>
import 'jquery-ui/themes/base/core.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/themes/base/sortable.css'
import 'jquery-ui/ui/widgets/sortable'
import 'pivottable'
import 'pivottable/dist/plotly_renderers'
import 'jquery-ui-touch-punch'
import 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
import { mapState } from 'vuex'
import api from '@/api'
import { getDate, getUserProjectPermissions } from '@/lib/utils'
import { getExchangeRate } from '@/lib/exchangeRate'
import ProjectToolbar from './ProjectToolbar'

function getCategory(sku) {
  const dividers = ['from', 'to', 'in']

  for (let i = 0; i < dividers.length; i += 1) {
    const idx = sku.indexOf(` ${dividers[i]} `)
    if (idx !== -1) {
      return sku.substr(0, idx)
    }
  }

  return sku
}

function fillDefault(defaultValue) {
  return (value) =>
    value === null || value === undefined || value === '' ? defaultValue : value
}

const fillNA = fillDefault('N/A')
const SET_KEY = 'costPivot.preset'

export default {
  components: { ProjectToolbar },

  data: () => ({
    pivotData: [],
    rendererType: 'Table',
    presets: [],
    selectedPreset: null,
    dialog: {
      remove: false,
      saveAs: false,
      duplicate: false,
      item: {
        name: '',
      },
    },
    userProjectPermissions: [],
    rawData: [],
    isTagsShow: true,
    useSelectBox: false,
    monthArray: [],
    pickupStrMonth: null,
    pickupEndMonth: null,
    months: [],
    dateType: 'oneMonth',
    disableStrDates() {
      return (date) => {
        const from = moment(date)
        const threeMonths = moment(this.pickupEndMonth).subtract(6, 'month')
        if (this.pickupEndMonth && !this.pickupStrMonth) {
          const selectedMonth = moment(this.pickupEndMonth)
          return threeMonths.isAfter(from) || !selectedMonth.isAfter(from)
        }
        if (this.pickupEndMonth && this.pickupStrMonth) {
          return threeMonths.isAfter(from)
        }
        return false
      }
    },
    disableEndDates() {
      return (date) => {
        const from = moment(date)
        if (this.pickupStrMonth) {
          const threeMonths = moment(this.pickupStrMonth).add(6, 'month')
          const selectedMonth = moment(this.pickupStrMonth)
          return threeMonths.isBefore(from) || !selectedMonth.isBefore(from)
        }
        return false
      }
    },
  }),

  mounted() {
    this.monthType(this.dateType)
    this.loadSetting()

    $('.datePicker').find('input').attr('disabled', 'disabled')
    $('.datePicker').find('input').eq(0).attr('placeholder', 'Start Date')
    $('.datePicker').find('input').eq(1).attr('placeholder', 'End Date')
  },

  computed: {
    ...mapState({
      curAccount: (state) => state.curAccount,
      userInfo: (state) => state.userInfo,
      exchangeRateList: (state) => state.exchangeRateList,
      displayCurrency: (state) => state.displayCurrency,
    }),

    canDownload() {
      const downloadable = [
        'Table',
        'Heatmap',
        'Row Heatmap',
        'Col Heatmap',
        'Table Barchart',
      ]
      return downloadable.includes(this.rendererType)
    },

    disabled() {
      return !this.rawData.length
    },
  },

  watch: {
    curAccount(newAccount, oldAccount) {
      if (oldAccount && newAccount !== oldAccount) this.move()
      else this.load()
    },
    months() {
      this.load()
    },
    userInfo() {
      this.loadSetting()
    },
    pickupStrMonth(newDate, oldDate) {
      if (!oldDate) return
      this.changeRangeMonth()
    },
    pickupEndMonth(newDate, oldDate) {
      if (!oldDate) return
      this.changeRangeMonth()
    },
    isTagsShow() {
      this.showTagsCategories()
    },
    displayCurrency() {
      this.load()
    },
  },

  methods: {
    L(path) {
      return this.$t(`billing.costPivot.${path}`)
    },

    loadSetting() {
      if (!this.userInfo.seq) return

      api.userSetting
        .list(this.userInfo.seq, 'costPivot.preset')
        .then((res) => {
          this.presets = res
        })
    },

    async load() {
      if (!this.curAccount.id || !this.months.length) return
      const months = [this.months[0]]
      if (this.months.length === 2) {
        const from = moment(this.months[0]).add(1, 'month')
        const to = moment(this.months[1])
        while (from.isSameOrBefore(to)) {
          months.push(from.format('YYYY-MM'))
          from.add(1, 'month')
        }
      }
      await getExchangeRate(months)

      this.userProjectPermissions = getUserProjectPermissions(
        this.userInfo.resource,
        this.curAccount
      )
      this.loadData()
    },

    loadData() {
      const params = {
        options: this.getPivotOptions(),
        id: this.curAccount.id,
        projects: this.userProjectPermissions,
      }
      switch (this.dateType) {
        case 'oneMonth':
          params.period = 1
          params.month = this.months[0].replace(/-/g, '')
          break
        case 'threeMonths':
          params.period = 3
          params.month = this.months[1].replace(/-/g, '')
          break
        default: {
          const { startDate, endDate } = this.setTerm(
            this.months[0],
            this.months[this.months.length - 1]
          )
          params.startDate = startDate
          params.endDate = endDate
          break
        }
      }
      this.loadUsageDaily(api.usage.dailyFromBq(params))
    },

    loadUsageDaily(usage) {
      return usage
        .then((data) => {
          this.checkPivotData(data)
        })
        .then(() => {
          this.showTagsCategories()
        })
    },

    loadPreset(preset) {
      api.userSetting
        .get(this.userInfo.seq, SET_KEY, preset.name)
        .then(() => {
          this.selectedPreset = preset
          this.load()
        })
        .then(() => {
          this.showTagsCategories()
        })
    },

    save() {
      api.userSetting.modify(
        this.userInfo.seq,
        SET_KEY,
        this.selectedPreset.name,
        this.selectedPreset.data
      )
    },

    openSaveAs() {
      this.dialog.saveAs = true
    },

    closeSaveAs() {
      this.dialog.saveAs = false
    },

    saveAs() {
      if (this.dialog.item.name.length > 0) {
        const params = {
          name: this.dialog.item.name,
          data: this.getPivotOptions(),
        }
        const presetNameArray = this.presets.map((x) => x.name)
        if (!presetNameArray.includes(this.dialog.item.name)) {
          this.closeSaveAs()
          api.userSetting.add(this.userInfo.seq, SET_KEY, params).then(() => {
            this.dialog.duplicate = false
            this.loadSetting()
          })
        } else {
          this.dialog.duplicate = true
        }
      }
    },

    openRemove() {
      this.dialog.remove = true
    },

    remove() {
      api.userSetting
        .remove(this.userInfo.seq, SET_KEY, this.selectedPreset.name)
        .then(() => {
          this.selectedPreset = null
          this.loadSetting()
        })
    },

    setPivotOptions(options) {
      return {
        rows: options ? options.rows : ['Service'],
        cols: options ? options.cols : [],
        vals: options ? options.vals : ['FinalCost'],
        rowOrder: options ? options.rowOrder : 'key_a_to_z',
        colOrder: options ? options.colOrder : 'key_a_to_z',
        aggregatorName: options ? options.aggregatorName : 'Sum',
        rendererName: options ? options.crendererNameols : 'Table',
        exclusions: options ? options.exclusions : {},
      }
    },

    getPivotOptions() {
      if (!$(this.$refs.pivot).data('pivotUIOptions')) {
        return this.setPivotOptions(null)
      }
      if (this.selectedPreset) {
        return this.setPivotOptions(this.selectedPreset.data)
      }
      const options = JSON.parse(
        JSON.stringify($(this.$refs.pivot).data('pivotUIOptions'))
      )
      return this.setPivotOptions(options)
    },

    createPivot(options) {
      this.pivotData = this.rawData
        .filter(
          (elem) => !(elem.cost === 0 && elem.credit === 0 && elem.usage === 0)
        )
        .map((elem) => {
          const data = {
            Invoice: elem.invoice_month,
            Project:
              this.$config.platform.id === 'gcp'
                ? elem.project_id
                : elem.project_name,
            Service: elem.service_name,
            Product: elem.sku_name,
            ProductCategory: getCategory(elem.sku_name ? elem.sku_name : ''),
            YMD: elem.usage_date,
            YM: elem.usage_date ? elem.usage_date.substr(0, 7) : '',
            D: elem.usage_date ? elem.usage_date.substr(8, 9) : '',
            Location: elem.location,
            Country: elem.country_name || 'Global',
            Region: elem.region,
            Zone: elem.zone,
            Cost: elem.cost,
            Usage: elem.usage,
            Discount: elem.credit,
            FinalCost: elem.cost + elem.credit,
          }

          if (this.$config.feature.tags) {
            data['T:Cores'] = fillNA(elem.t_system_cores)
            data['T:MachineSpec'] = fillNA(elem.t_system_machine_spec)
            data['T:Memory'] = fillNA(elem.t_system_memory)
            data['T:Application'] = fillNA(elem.t_user_application)
            data['T:Environment'] = fillNA(elem.t_user_environment)
            data['T:Name'] = fillNA(elem.t_user_name)
            data['T:Owner'] = fillNA(elem.t_user_owner)
            data['T:Phase'] = fillNA(elem.t_user_phase)
            data['T:Project'] = fillNA(elem.t_user_project)
            data['T:Revision'] = fillNA(elem.t_user_revision)
            data['T:Role'] = fillNA(elem.t_user_role)
            data['T:Server'] = fillNA(elem.t_user_server)
            data['T:Service'] = fillNA(elem.t_user_service)
            data['T:Status'] = fillNA(elem.t_user_status)
            data['T:Team'] = fillNA(elem.t_user_team)
            data['T:User'] = fillNA(elem.t_user_user)
          }
          this.$config.billing.costPivot.excludeFields.forEach((f) => {
            delete data[f]
          })
          return data
        })

      this.rawData.splice(0, this.rawData.length)
      const renderers = $.extend(
        $.pivotUtilities.renderers,
        $.pivotUtilities.plotly_renderers
      )

      const pivotAgg = []
      const pivotAttr = []
      const objKeys = Object.keys(this.pivotData[0])
      objKeys.forEach((item) => {
        if (
          item !== 'Cost' &&
          item !== 'Discount' &&
          item !== 'Usage' &&
          item !== 'FinalCost'
        ) {
          pivotAgg.push(item)
        } else {
          pivotAttr.push(item)
        }
      })

      const tpl = $.pivotUtilities.aggregatorTemplates
      const renderOptions = Object.assign(options, {
        renderers,
        unusedAttrsVertical: false,
        hiddenFromDragDrop: pivotAttr,
        hiddenFromAggregators: pivotAgg,
        aggregators: {
          Count: () => tpl.count()(),
          Sum: (list) => tpl.sum()(list),
          Average: (list) => tpl.average()(list),
          Minimun: (list) => tpl.min()(list),
          Maximum: (list) => tpl.max()(list),
        },
        menuLimit: 2000,
      })

      renderOptions.onRefresh = (option) => {
        if (this.selectedPreset) {
          this.selectedPreset.data = this.setPivotOptions(option)
        }
        const aggregators = {
          Count: tpl.count()(),
          Sum: tpl.sum()(renderOptions.vals),
          Average: tpl.average()(renderOptions.vals),
          Minimun: tpl.min()(renderOptions.vals),
          Maximum: tpl.max()(renderOptions.vals),
        }
        renderOptions.exclusions = option.exclusions
        renderOptions.aggregator = aggregators[renderOptions.aggregatorName]

        renderOptions.filter = (record) => {
          let excludedItems = null
          function indexOf(item) {
            for (let i = 0, l = this.length; i < l; i += 1) {
              if (i in this && this[i] === item) return i
            }
            return -1
          }

          const exclusions = Object.keys(renderOptions.exclusions)
          for (let i = 0; i < exclusions.length; i += 1) {
            const key = exclusions[i]
            excludedItems = renderOptions.exclusions[key]
            if (indexOf.call(excludedItems, record[key]) >= 0) {
              return false
            }
          }
          return true
        }

        renderOptions.hiddenFromAggregators.forEach((item, i) => {
          if (
            !renderOptions.rows.includes(item) &&
            !renderOptions.cols.includes(item)
          ) {
            $(`.axis_${i} .pvtTriangle`).css('display', 'none')
          }
        })

        $('.pvtRendererArea').pivot(this.pivotData, renderOptions)
      }

      $(this.$refs.pivot).pivotUI(this.pivotData, renderOptions, true)

      $.each($('.pvtAttr'), (idx, item) => {
        if (item.innerText === 'D ▾') {
          $(item).find('.pvtTriangle').remove()
        }
        if (item.innerText.includes('T:')) {
          $(item).parent().addClass('tag-categories')
        }
      })

      this.graphType = $(this.$refs.pivot).find('.pvtRenderer').val()
    },

    download(fileType) {
      XLSX.writeFile(
        XLSX.utils.table_to_book($('.pvtTable')[0]),
        `Cost Pivot_${this.curAccount.name}_${this.months.join(
          '_'
        )}.${fileType}`
      )
    },

    pivotChanged() {
      this.rendererType = $(this.$refs.pivot).find('.pvtRenderer').val()
    },

    monthType(type) {
      this.dateType = type
      if (type === 'oneMonth' || type === 'threeMonths') {
        this.useSelectBox = true
        this.monthArray = getDate(type)
        this.changeMonth(this.monthArray[0])
      } else {
        this.useSelectBox = false
        this.changeRangeMonth()
      }
    },

    changeRangeMonth() {
      if (!this.pickupEndMonth || !this.pickupStrMonth) return

      const to = moment(this.pickupStrMonth)
      const months = moment(this.pickupStrMonth).add(6, 'month')
      const from = moment(this.pickupEndMonth)

      if ((!from.isBefore(to) && to.isBefore(months)) || from.isSame(months)) {
        this.changeMonth(
          `${moment(this.pickupStrMonth).format('YYYY-MM-DD')}~${moment(
            this.pickupEndMonth
          ).format('YYYY-MM-DD')}`
        )
        this.monthArray = []
      }
    },

    changeMonth(month) {
      this.months = month.split('~')
    },

    showTagsCategories() {
      if (this.isTagsShow) {
        $('.tag-categories').addClass('show')
        $('.tag-categories').removeClass('hide')
      } else {
        $('.tag-categories').removeClass('show')
        $('.tag-categories').addClass('hide')
      }
    },

    getExchangeRate(currency, context) {
      const er = this.exchangeRateList.find(
        (e) => e.month === context.month && e.code === currency
      )
      return er ? er.send_rate : { finalCost: 0 }
    },

    checkPivotData(data) {
      if (data.length > 0) {
        const month = moment(data[0].invoice_month).format('YYYY-MM')
        this.rawData = this.convertDailyCosts(
          data,
          this.displayCurrency,
          this.getExchangeRate.bind(this),
          { month }
        )
        this.createPivot(this.getPivotOptions())
      } else {
        this.$refs.pivot.innerHTML = `
          <p style="text-align: center; margin-top: 100px">데이터가 없습니다.</p>
        `
      }
    },

    setTerm(strMonth, endMonth) {
      return {
        startDate:
          strMonth.match(/-/g).length <= 1
            ? moment(new Date(strMonth)).format('YYYY-MM-DD')
            : strMonth,
        endDate:
          endMonth.match(/-/g).length <= 1
            ? moment(new Date(endMonth))
                .add(1, 'month')
                .date(0)
                .format('YYYY-MM-DD')
            : endMonth,
      }
    },

    move() {
      const enabledBq = this.$config.bq.accounts.includes(this.curAccount.id)
      if (!enabledBq) {
        this.$router.replace('/billing/cost_pivot')
      } else {
        this.load()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.md-content {
  padding: 16px;
}

.datePicker {
  width: 150px;
  min-height: 0px;
  max-height: 20px;
  top: 3px;
  padding: 0;
  margin: 0;
}

@media (max-width: 800px) {
  .md-toolbar.md-dense {
    min-width: 460px;
  }

  .md-checkbox {
    width: 100px;
    margin: 16px 16px 16px 0;
    display: inline-flex;
    position: relative;
  }

  .md-checkbox {
    ::v-deep .md-checkbox-label {
      height: 20px;
      padding-left: 16px;
      position: relative;
      line-height: 15px;
      width: 100%;
    }
  }
}
</style>

<style lang="scss">
@import '../../assets/scss/pivot.scss';

.presetList div {
  min-height: 35px;
  padding: 3px 10px 3px 10px;
}

.md-datepicker .md-date-icon {
  margin-top: -5px;
}

.datePicker .md-input {
  height: auto;
  font-size: 12px;
  line-height: 0px;
}

.md-datepicker-body-content {
  height: 250px !important;
}

.datePicker button {
  display: none;
}

.pvtUnused .tag-categories.hide {
  display: none;
}

.pvtUnused .tag-categories.show {
  display: inline-block;
}

.loadBtn {
  margin-left: auto;
  margin-bottom: 20px;
}
</style>
